import { GAME_CONFIG } from './gameConfig';

// Timing is measured in seconds, independent of scroll speed or frame rate.
export const getHitWindow = (tolerance) => (
  tolerance / GAME_CONFIG.noteSpeed * GAME_CONFIG.rhythm.toleranceScale
);

export const judgeHit = (offset, tolerance) => {
  const distance = Math.abs(offset);
  const window = getHitWindow(tolerance);
  if (distance > window) return null;
  if (distance <= Math.min(GAME_CONFIG.rhythm.perfectWindow, window * 0.4)) return 'perfect';
  if (distance <= Math.min(GAME_CONFIG.rhythm.greatWindow, window * 0.75)) return 'great';
  return 'good';
};

export const JUDGEMENTS = {
  perfect: { label: 'Perfecto', weight: 1, color: '#F7E04B' },
  great: { label: 'Genial', weight: 0.8, color: '#C5E6A0' },
  good: { label: 'Bien', weight: 0.5, color: '#ffffff' },
};

export const getComboMultiplier = (combo) => (
  1 + GAME_CONFIG.rhythm.comboMilestones.filter((milestone) => combo >= milestone).length
);

export const registerHit = (state, judgement) => {
  state.totalHits += 1;
  state.judgements[judgement] += 1;
  state.accuracyWeight += JUDGEMENTS[judgement].weight;
  state.combo += 1;
  state.maxCombo = Math.max(state.maxCombo, state.combo);
  state.multiplier = getComboMultiplier(state.combo);
  state.score += GAME_CONFIG.score.bonusPerHit * JUDGEMENTS[judgement].weight * state.multiplier;
  state.timeLeft = Math.min(GAME_CONFIG.time.maxBuffer, state.timeLeft + 0.4 * JUDGEMENTS[judgement].weight);
  if (state.streakStartedAt === null) state.streakStartedAt = state.elapsedTime;
};

export const getAccuracy = (state) => {
  const judged = state.totalHits + state.totalMisses;
  return judged ? Math.round(state.accuracyWeight / judged * 1000) / 10 : 0;
};

export const getHoldProgress = (note, songTime) => (
  Math.max(0, Math.min(note.holdDuration, songTime - note.targetHitTime))
);

export const getHoldOutcome = (note, songTime, resumeHoldUntil = 0) => {
  if (!note.headHit) return null;
  if (note.pressed) return getHoldProgress(note, songTime) >= note.holdDuration ? 'complete' : null;
  if (note.releasedAt != null) {
    return note.holdDuration - getHoldProgress(note, note.releasedAt) <= GAME_CONFIG.notes.hold.releaseGraceSeconds
      ? 'complete' : 'miss';
  }
  // A paused hold gets a short chance to be picked up, never a free completion.
  return songTime > resumeHoldUntil ? 'miss' : null;
};
